import {
  Provider,
  QueryAndOutputs,
  WorkflowCodeType,
  WorkflowComponentCodeParams,
  WorkflowComponentOutputTablesParams,
  WorkflowComponentOutputType,
  WorkflowComponentParamType
} from '../types'
import { WorkflowComponent } from './common/workflowcomponent'

class GetTableByName extends WorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.gettablebyname',
        group: 'Input/Output',
        title: 'Get Table by Name',
        description:
          'Load a table as a source in the workflow using its FQN e.g.: mydata.tables.table'
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.String,
          title: 'Source table FQN',
          placeholder: 'mydata.tables.mytable',
          validation:
            '^[a-zA-Z_][a-zA-Z0-9_-]*\\.[a-zA-Z_][a-zA-Z0-9_-]*\\.[a-zA-Z_][a-zA-Z0-9_-]*$'
        }
      ],
      [
        {
          name: 'out',
          title: 'Table',
          description: 'The output table',
          type: WorkflowComponentOutputType.Table
        }
      ]
    )
    this.requiresDynamicSQL = true
  }

  cleanValue(value: string) {
    return value.replace(/[()'"`]/g, '') // remove parentheses and quotes if expression
  }

  async getCode({
    workflow,
    params,
    connection,
    componentName,
    codeType
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs | null> {
    let outputname = connection.getOutputViewName(
      workflow.id,
      componentName,
      params,
      'out',
      codeType
    )
    if (codeType === WorkflowCodeType.StoredProcedure) {
      outputname = connection.getOutputTableName(
        workflow.id,
        componentName,
        params,
        'out',
        codeType
      )
    }
    let source = (params.source as string).replace(/[()'"`]/g, '')
    if (codeType !== WorkflowCodeType.StoredProcedure) {
      // variable substitution is done here instead of in a later step, since this requires a particular handling
      // the substitution that will happen later will have no effect.
      const sortedVariables = workflow.variables
        .slice()
        .sort((a, b) => (a.name < b.name ? 1 : b.name < a.name ? -1 : 0))
      for (const variable of sortedVariables) {
        source = source.replace(
          RegExp(`@${variable.name}`, 'g'),
          connection.quoteName(variable.value)
        )
      }
    }
    let query = ''
    if (connection.type === Provider.DatabricksRest) {
      query = connection.getCreateTempViewQuery(
        outputname,
        `select /*+ REPARTITION(40) */ * from ${connection.quoteName(
          source.replace(/`/g, '')
        )}`,
        codeType
      )
    } else {
      if (codeType === WorkflowCodeType.StoredProcedure) {
        query = connection.getCreateTempTableQuery(
          outputname,
          `select * from ${connection.quoteName(source.replace(/`/g, ''))}`,
          codeType,
          null
        )
      } else {
        query = connection.getCreateTempViewQuery(
          outputname,
          `select * from ${connection.quoteName(source.replace(/`/g, ''))}`,
          codeType
        )
      }
    }

    return {
      query,
      outputs: { out: outputname }
    }
  }

  getOutputTables({
    params,
    connection,
    workflow,
    componentName,
    codeType
  }: WorkflowComponentOutputTablesParams): Record<string, string> {
    const viewname = connection.getOutputViewName(
      workflow.id,
      componentName,
      params,
      'out',
      codeType
    )
    return { out: viewname }
  }
}

export { GetTableByName }
